
import {STORE_OPEN_COMMENT_ID,  STORE_APP_COMMENT_CURRENT_INFO, STORE_APP_EQUATION_CURRENT_INFO,  STORE_OPEN_PROBLEM_SET, STORE_APP_NOTES_CURRENT_INFO, STORE_CURRENT_HIGHLIGHTED_ITEM } from '../constants/actionConstants';

// Stores information about the current state of the app
const AppReducer = (state={showProblems:true, commentCurrentInfo:undefined,  equationCurrentInfo: undefined, notesCurrentInfo:undefined,
                                              openNotesID: undefined, openCommentID: undefined, openProblemSet: undefined, openProblemIndex: 0,
                                              highlighted:{frame_id: undefined, title:"", equation:"", text:""},
                                            }, action)=>{


    switch(action.type){
        // If not locked, then id of current info or undefined
        case STORE_APP_COMMENT_CURRENT_INFO:
            return {...state, commentCurrentInfo: action.payload}
        // Stores information that is highlighted so we can ask a question about it
        case STORE_CURRENT_HIGHLIGHTED_ITEM:
            console.log(action.payload)
            return {...state,  highlighted: action.payload} 
        case STORE_APP_NOTES_CURRENT_INFO:
            return {...state, notesCurrentInfo: action.payload}
        case STORE_APP_EQUATION_CURRENT_INFO:
            return {...state, equationCurrentInfo: action.payload}
        case STORE_OPEN_COMMENT_ID:
            return {...state, openCommentID: action.payload}
        case STORE_OPEN_PROBLEM_SET:
            return {...state, openProblemSet: action.payload.id, openProblemIndex:action.payload.open_problem}

        default:
            return state ; 
    }
}

export default AppReducer ; 

